var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#f4f4f4;}.cls-4{fill:#323e95;}.cls-5{fill:#d8001e;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 5,
    width: 24,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RUSSIA"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 24,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 4.67,
    width: 24,
    height: 4.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 9.34,
    width: 24,
    height: 4.67
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.5c19220cb5e64239b301e26b28e25e66.svg";
export { ForwardRef as ReactComponent };